import React from 'react';
import './pages.css';
import Contact from '../components/Contact';

const ContactPage = () => {
  return (
    <div>
      
      <Contact />
    </div>
  );
};

export default ContactPage;
